import {
  SHOPIFY_ACCOUNTS,
  SHOPIFY_BILLING_CANCEL,
  SHOPIFY_BILLING_PLANS,
  SHOPIFY_BILLING_SUBSCRIBE,
  SHOPIFY_BILLING_UPDATE_CAPPED_AMOUNT,
  SHOPIFY_OAUTH_URL,
  SHOPIFY_REVENUE,
  SHOPIFY_REVOKE_ACCESS_TOKEN,
  SHOPIFY_REVOKE_TOKEN,
  SHOPIFY_SHOP,
  SHOPIFY_SHOPS,
} from '@mm/api-routes';
import { ShopifyPlan, ShopifyRevenueResponse } from '../model/ShopifyModel';
import AuthenticatedController from './AuthenticatedController';
import { ShopifyData, ShopifyShop } from '../interfaces/shopify';
import { Pagination } from '../store-interfaces';

export default class ShopifyController extends AuthenticatedController {
  static async getShops(): Promise<{
    shops: ShopifyData;
    pagination: Pagination;
  }> {
    return super.get(SHOPIFY_SHOPS);
  }

  static async getShop(id: number | string): Promise<ShopifyShop> {
    return super.get(SHOPIFY_SHOP(id));
  }

  static async getShopifyPlans(): Promise<{ plans: ShopifyPlan[] }> {
    return super.get(SHOPIFY_BILLING_PLANS);
  }

  static async subscribeShopifyPlan(
    shopId: number,
    planId: number,
  ): Promise<{ confirmationUrl: string }> {
    return super.post(SHOPIFY_BILLING_SUBSCRIBE, {
      shopId,
      planId,
    });
  }

  static async cancelShopifyPlan(
    shopId: number,
  ): Promise<{ success: boolean }> {
    return super.get(SHOPIFY_BILLING_CANCEL, {
      shop_id: shopId,
    });
  }

  static async updateCappedAmount(
    shopId: number,
    cappedAmount: number,
  ): Promise<{ updateCappedAmountUrl: string }> {
    return super.get(SHOPIFY_BILLING_UPDATE_CAPPED_AMOUNT, {
      shop_id: shopId,
      capped_amount: cappedAmount,
    });
  }

  static async getOauthUrl(shop: string, facebookPageId: number) {
    return super.get(SHOPIFY_OAUTH_URL, {
      shop,
      facebook_page_id: facebookPageId,
    });
  }

  static async getAccounts(facebookPageId: number) {
    return super.get(SHOPIFY_ACCOUNTS, {
      facebook_page_id: facebookPageId,
    });
  }

  static async revokeToken(tokenId: number) {
    return super.post(SHOPIFY_REVOKE_TOKEN, {
      token_id: tokenId,
    });
  }

  static async getRevenue(facebookPageId): Promise<ShopifyRevenueResponse> {
    return super.get(SHOPIFY_REVENUE, {
      facebook_page_id: facebookPageId,
    });
  }

  static async revokeAccessToken(tokenId: number) {
    const path = SHOPIFY_REVOKE_ACCESS_TOKEN(tokenId);
    return super.post(path);
  }
}
